import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Input from "./Components/Input";
import Button from "./Components/Button";

const API_URL = process.env.REACT_APP_API_URL


function Login() {
    const [formData, setFormData] = useState({ user: "", password: "" });
    const navigate = useNavigate();

    const handleInputChange = (e) => {
        const { id, value } = e.target;
        setFormData({ ...formData, [id]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {   
            console.log(API_URL || "api not found :(")
            const url = `${API_URL}/login`
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            });

            const result = await response.json();
            console.log("Response:", result);

            if (response.ok) {
                toast.success(result.message, { autoClose: 2000 });
                setTimeout(() => navigate("/home"), 2000);
            } else {
                toast.error(result.message || "Login failed", { autoClose: 3000 });
            }
        } catch (error) {
            console.error("Error during login:", error);
            toast.error("An error occurred. Please try again.", { autoClose: 3000 });
        }
    };

    return (
        <div className="container">
            <div className="card m-3 p-3">
                <form onSubmit={handleSubmit}>
                    <Input
                        label="User"
                        type="text"
                        id="user"
                        placeholder="Enter username"
                        value={formData.user}
                        onChange={handleInputChange}
                    />
                    <Input
                        label="Password"
                        type="password"
                        id="password"
                        placeholder="Enter password"
                        value={formData.password}
                        onChange={handleInputChange}
                    />
                    <Button type="submit" text="Login" />
                </form>
            </div>
            <ToastContainer />
        </div>
    );
}

export default Login;
